import { WidgetConfiguration } from 'types';
import { resolveWidgetLocale } from 'utils/locale';
import {
  DataAttribute,
  ExtractDataReturnType,
  ExtractOgReturnType,
  OgTag,
  OgTagKeys,
  OgTagSelector,
  WidgetConfigProvider,
} from './types';

function extractOgTags<T extends OgTag[]>(...tags: T): ExtractOgReturnType<T> {
  return tags.reduce((acc, val) => {
    const tag = document.querySelector(OgTagSelector[val]);

    if (tag) {
      const content = tag.getAttribute('content');

      if (content) {
        acc[OgTagKeys[val]] = content;
      }
    }

    return acc;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  }, {} as any);
}

function extractDataAttrs<D extends DataAttribute[]>(
  el: Element | null,
  ...attrs: D
): ExtractDataReturnType<D> {
  if (!el || !(el instanceof HTMLElement)) return {};

  return attrs.reduce((acc, val) => {
    const value = el.dataset[val];
    const key = val;
    acc[key] = value;
    return acc;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  }, {} as any) as any;
}

const domConfigProvider: WidgetConfigProvider = (injectionPoint) => {
  const og = extractOgTags(...Object.values(OgTag));
  const { locale, ...data } = extractDataAttrs(
    injectionPoint,
    ...Object.values(DataAttribute),
  );

  const config: Partial<WidgetConfiguration> = {
    // fallback url - will be overridden by og.url if an og:url tag exists
    url: window.location.href,
    ...og,
    ...data,
  };

  if (locale !== undefined) {
    config.locale = resolveWidgetLocale(locale);
  }

  return config;
};

export default domConfigProvider;
